import { httpClient } from "ultis/axios";

/**api lấy danh sách hàng đợi */
const getListQueue = (params) => {
  return httpClient.get("/cloud-pbx/queue", {
    params,
  });
};

const getCountListQueue = (params) => {
  return httpClient.get("/cloud-pbx/queue/count", {
    params,
  });
};

const getQueueDetail = (id) => {
  return httpClient.get(`/cloud-pbx/queue/${id}`);
};

const createQueue = (payload) => {
  return httpClient.post("/cloud-pbx/queue", payload);
};

const editQueue = (id, payload) => {
  return httpClient.put(`/cloud-pbx/queue/${id}`, payload);
};

const deleteQueue = (id) => {
  return httpClient.delete(`/cloud-pbx/queue/${id}`);
};

export const QueueApi = {
  getListQueue,
  getCountListQueue,
  createQueue,
  editQueue,
  deleteQueue,
  getQueueDetail,
};
